export default __webpack_public_path__ + "static/media/main-2.e709e241.jpg";